// URL Redirects Configuration
// This file contains all 301 redirects for the site
// Format: [oldPath]: newPath

export const redirectMapping: Record<string, string> = {
  // Contact redirects
  '/contact-us': '/contact',

  // Retired page - kept for search traffic
  '/about': '/our-story',

  // WA first school year is Pre-primary, not Kindergarten
  '/programs/wa/kindergarten-foundations-english-tutoring': '/programs/wa/pre-primary-foundations-english-tutoring',
  '/programs/wa/kindergarten-foundations-maths-tutoring': '/programs/wa/pre-primary-foundations-maths-tutoring',
  
  // Service area redirects - old URLs to new tutoring-prefixed URLs
  '/service-areas/marsden-park': '/tutoring-marsden-park',
  '/service-areas/blacktown': '/tutoring-blacktown',
  '/service-areas/castle-hill': '/tutoring-castle-hill',
  '/service-areas/liverpool': '/tutoring-liverpool',
  '/service-areas/hurstville': '/tutoring-hurstville',
  '/service-areas/newtown': '/tutoring-newtown',
  '/service-areas/seven-hills': '/tutoring-seven-hills',
  '/service-areas/penrith': '/tutoring-penrith',
  '/service-areas/st-marys': '/tutoring-st-marys',
  '/service-areas/doonside': '/tutoring-doonside',
  '/service-areas/rooty-hill': '/tutoring-rooty-hill',
  '/service-areas/mount-druitt': '/tutoring-mount-druitt',
  '/service-areas/granville': '/tutoring-granville',
  '/service-areas/ryde': '/tutoring-ryde',
  '/service-areas/baulkham-hills': '/tutoring-baulkham-hills',
  '/service-areas/bankstown': '/tutoring-bankstown',
  '/service-areas/merrylands': '/tutoring-merrylands',
  '/service-areas/chatswood': '/tutoring-chatswood',
  '/service-areas/campbelltown': '/tutoring-campbelltown',
  '/service-areas/epping': '/tutoring-epping',
  '/service-areas/marrickville': '/tutoring-marrickville',
  '/service-areas/quakers-hill': '/tutoring-quakers-hill',
  '/service-areas/guildford': '/tutoring-guildford',
  '/service-areas/auburn': '/tutoring-auburn',
  '/service-areas/lidcombe': '/tutoring-lidcombe',
  '/service-areas/carlingford': '/tutoring-carlingford',
  '/service-areas/revesby': '/tutoring-revesby',
  '/service-areas/padstow': '/tutoring-padstow',
  '/service-areas/panania': '/tutoring-panania',
  '/service-areas/hornsby': '/tutoring-hornsby',
  '/service-areas/dee-why': '/tutoring-dee-why',
  '/service-areas/st-ives': '/tutoring-st-ives',
  '/service-areas/macquarie-park': '/tutoring-macquarie-park',
  '/service-areas/frenchs-forest': '/tutoring-frenchs-forest',
  '/service-areas/cherrybrook': '/tutoring-cherrybrook',
  '/service-areas/casula': '/tutoring-casula',
  '/service-areas/fairfield': '/tutoring-fairfield',
  '/service-areas/parramatta': '/tutoring-parramatta',
  '/service-areas/sutherland': '/tutoring-sutherland',
  '/service-areas/strathfield': '/tutoring-strathfield',
  '/service-areas/kogarah': '/tutoring-kogarah',
  '/service-areas/ashfield': '/tutoring-ashfield',
  '/service-areas/randwick': '/tutoring-randwick',
  '/service-areas/bondi': '/tutoring-bondi',
  '/service-areas/eastwood': '/tutoring-eastwood',
  '/service-areas/leichhardt': '/tutoring-leichhardt',
  '/service-areas/stanhope-gardens': '/tutoring-stanhope-gardens',
  '/service-areas/kellyville': '/tutoring-kellyville',
  '/service-areas/norwest': '/tutoring-norwest',
  '/service-areas/emu-plains': '/tutoring-emu-plains',
  '/service-areas/schofields': '/tutoring-schofields',
  '/service-areas/box-hill': '/tutoring-box-hill',
  
  // Victorian service area redirects
  '/service-areas/tarneit': '/tutoring-tarneit',
  '/service-areas/truganina': '/tutoring-truganina',
  '/service-areas/glenwood': '/tutoring-glenwood',
  '/service-areas/zetland': '/tutoring-zetland',
  '/service-areas/cronulla': '/tutoring-cronulla',
  '/service-areas/miranda': '/tutoring-miranda',
  '/service-areas/south-caringbah': '/tutoring-south-caringbah',
  '/service-areas/bexley': '/tutoring-bexley',
  '/service-areas/menai': '/tutoring-menai',
  '/service-areas/wollongong': '/tutoring-wollongong',
  '/service-areas/rockdale': '/tutoring-rockdale',
  '/service-areas/manly': '/tutoring-manly',
  '/service-areas/mona-vale': '/tutoring-mona-vale',
  '/service-areas/paddington': '/tutoring-paddington',
  '/service-areas/east-lakes': '/tutoring-east-lakes',
  '/service-areas/mascot': '/tutoring-mascot',
  '/service-areas/pagewood': '/tutoring-pagewood',
  '/service-areas/prestons': '/tutoring-prestons',
  '/service-areas/ingleburn': '/tutoring-ingleburn',
  '/service-areas/campsie': '/tutoring-campsie',
  '/service-areas/minto': '/tutoring-minto',
  '/service-areas/oran-park': '/tutoring-oran-park',
  '/service-areas/gregory-hills': '/tutoring-gregory-hills',
  '/service-areas/narellan': '/tutoring-narellan',
  '/service-areas/punchbowl': '/tutoring-punchbowl',
  '/service-areas/dural': '/tutoring-dural',
  '/service-areas/west-pennant-hills': '/tutoring-west-pennant-hills',
  
  // Program redirects
  '/selective-test-preparation': '/programs/selective-school',
  '/oc-test-preparation': '/programs/oc-preparation',
  
  '/naplan-assessment': '/programs/naplan-preparation',
  '/courses-2': '/programs',
  '/blogs': '/newsroom',
  '/course-timetable': '/programs',
  '/year-1': '/programs/foundations',
  '/year-2': '/programs/foundations',
  '/year-3': '/programs/foundations',
  '/year-4': '/programs/foundations',
  '/year-5': '/programs/foundations',
  '/year-6': '/programs/foundations',
  '/book-now': '/book-assessment',
  '/bookanassessment/': '/book-assessment',
  '/colebee': '/centres/colebee',
  
  // Student Smart blog redirects to newsroom
  '/student-smart/why-is-taking-practice-tests-important': '/newsroom',
  '/student-smart/previous-test-paper': '/newsroom',
  '/student-smart/aiming-for-excellence-achieving-top-marks-in-the-selective-exam': '/newsroom',
  '/student-smart/the-selective-test-as-an-opportunity-class-placement-tests': '/newsroom',
  '/uncategorized/building-strong-foundations-the-importance-of-early-years-education': '/newsroom',
  '/student-smart/creative-learning-techniques-for-young-minds': '/newsroom',
  '/student-smart/the-role-of-play-in-early-childhood-learning': '/newsroom',
  '/student-smart/from-the-classroom-to-real-life-homework-challenges-for-young-students': '/newsroom',
  '/uncategorized/fostering-student-engagement-tips-for-teachers-and-parents': '/newsroom',
  '/uncategorized/filling-the-educational-void-tutoring-as-a-response-to-staff-shortages-in-schools': '/newsroom',
  '/uncategorized/collaboration-between-tutoring-in-schools-with-tutoring-in-the-australian-education-system': '/newsroom',
  '/student-smart/supporting-overstretched-schools-the-emergence-of-tutoring-centres-as-educational-pillars': '/newsroom',
  '/uncategorized/on-australian-mental-health-epidemic-and-how-schoolola-is-low-essential-for-primary-school-students': '/newsroom',
  '/student-smart/tutoring-a-safety-net-for-schools-facing-the-challenge-of-teacher-shortages': '/newsroom',
  '/uncategorized/on-australian-teacher-training': '/newsroom',
  '/scope': '/scope-exam',
  '/student-smart/breaking-news-schoolola-makes-its-debut-in-bella-vista-nsw': '/newsroom',
  '/su-test': '/scope-exam',
  '/the-schoolola-academy': '/partner-access-hub',
  '/kindy': '/programs/foundations',
  '/selective-mock-tests': '/programs/selective-school',
  '/biz/products': '/partner-access-hub',
  '/product/schoololateacher': '/partner-access-hub',
  '/product/branded-cape': '/partner-access-hub',
  '/product/30c-standard-balloon': '/partner-access-hub',
  '/product/selective-tmrw-study-materials-m1-5': '/programs/selective-school',
  '/biz/products/biz-cart': '/partner-access-hub',
  '/product/biz-cart/the-checkout': '/partner-access-hub',
  '/product/checkout': '/partner-access-hub',
  '/product/oc-tmrw-study-materials-m1-5': '/programs/oc-preparation',
  '/product/new-kindy-study-materials-m1-6': '/programs/foundations',
  '/product/y1-student-copy-m1-5': '/partner-access-hub',
  '/product/y2-student-copy-m1-5': '/partner-access-hub',
  '/product/y3-student-copy-m1-5': '/partner-access-hub',
  '/product/y4-student-copy-m1-5': '/partner-access-hub',
  '/product/y5-student-copy-m1-5': '/partner-access-hub',
  '/product/y6-student-copy-m1-5': '/partner-access-hub',
  '/product/new-design-course': '/partner-access-hub',
  '/uncategorized/oc-mock-tests': '/programs/oc-preparation',
  '/product/water-bottle-squeezed': '/partner-access-hub',
  '/product/schoolola-branded-t-shirts': '/partner-access-hub',
  '/parramatta': '/',
  '/schoolola-franchising': '/franchise',
  '/schoololafranchising': '/franchise',
  '/schoololafranchising/': '/franchise',
  '/franchise-eoI': '/franchise',
  '/au-mass-9900': '/partner-access-hub',
  '/girraween': '/',
  '/student-smart/2025-selective-test-weighting-changes': '/programs/selective-school',
  '/rouse-hill': '/centres/the-ponds',
  '/programs': '/programs',
  '/product/schoolola-branded-polo-shirts': '/partner-access-hub',
  '/scope-oc-practice-test-instruction-for-parents': '/programs/oc-preparation',
  '/scope-selective-practice-test-instruction-for-parents': '/programs/selective-school',
  '/product/oc-tmrw-teachers-copy-m1-5': '/programs/oc-preparation',
  '/student-smart/oc-tmrw-teachers-copy-m1-5': '/programs/oc-preparation',
  '/product/year-6-m1-5-study-materials-teachers-copy': '/partner-access-hub',
  '/product/year-5-m1-5-study-materials-teachers-copy': '/partner-access-hub',
  '/product/year-4-study-materials-teachers-copy': '/partner-access-hub',
  '/product/year-3-m1-5-study-materials-teachers-copy': '/partner-access-hub',
  '/product/year-2-study-materials-teachers-copy': '/partner-access-hub',
  '/product/year-1-m1-5-study-materials-teachers-copy': '/partner-access-hub',
  '/product/kindy-m1-5-study-materials-teachers-copy': '/partner-access-hub',
  '/scope/registration-confirmation-riverstonе': '/scope-exam',
  '/partner-help-desk': '/partner-access-hub',
  '/riverstone': '/centres/riverstone',
  '/tarneit': '/centres/tarneit',
  '/naplan-practice-tests': '/programs/naplan-preparation',
  '/product/y6-student-copy-m6-10': '/partner-access-hub',
  '/product/y5-student-copy-m6-10е': '/partner-access-hub',
  '/product/new-kindy-study-materials-m6-10': '/partner-access-hub',
  '/product/y4е-prep-study-materials-m6-10': '/partner-access-hub',
  '/product/y1c-prep-study-materials-m1-5': '/partner-access-hub',
  '/product/y2-student-copy-m6-10': '/partner-access-hub',
  '/product/y5-student-copy-m6-10': '/partner-access-hub',
  '/product/y3-student-copy-m6-10': '/partner-access-hub',
  '/product/y4-student-copy-m6-10': '/partner-access-hub',
  '/product/selective-tmrw-study-materials-m6-10': '/programs/selective-school',
  '/product/oc-tmrw-study-materials-m6-10': '/programs/oc-preparation',
  '/product/new-kindy-tmrw-teachers-copy-m6-10': '/programs/foundations',
  '/product/y1-student-copy-m6-10': '/partner-access-hub',
  '/product/kindy-m6-10-study-materials-teachers-copy': '/partner-access-hub',
  '/product/y1-m6-10-study-materials-teachers-copy': '/partner-access-hub',
  '/product/year-2-m6-10-study-materials-teacher-copy': '/partner-access-hub',
  '/product/year-3-m6-10-study-materials-teachers-copy-2': '/partner-access-hub',
  '/product/year-4-m1-5-study-materials-teachers-copy': '/partner-access-hub',
  '/product/year-5-m6-10-study-materials-teachers-copy': '/partner-access-hub',
  '/product/year-6-m6-10-study-materials-teachers-copy': '/partner-access-hub',
  '/uncategorized/naplan-600-breadst-voucher': '/programs/naplan-preparation',
  '/naplan-preparation': '/programs/naplan-preparation',
  '/canberra': '/centres',
  '/student-smart/naplan-year-5-your-ultimate-guide-to-success': '/newsroom',
  '/student-smart/crack-the-ssat': '/newsroom',
  '/bella-vista': '/',
  '/student-smart/scholarship-exam-course': '/programs/scholarship-exam-course',
  '/product/year-4-m6-10-study-materials-teachers-copy': '/partner-access-hub',
  '/product/year-3-m6-10-study-materials-teachers-copy': '/partner-access-hub',
  '/st-tutor': '/partner-access-hub',
  '/content': '/newsroom',
  '/au-schoolola-pty': '/partner-access-hub',
  '/accessible': '/partner-access-hub',
  '/franchising-invitations': '/franchise',
  '/product/schoolola-oc-and-selective-tmrw-leap-study-materials-m1-5-copy': '/programs/selective-school'
};